import { render, staticRenderFns } from "./TongpeiGoods.vue?vue&type=template&id=9bfe4492&scoped=true"
import script from "./TongpeiGoods.vue?vue&type=script&lang=js"
export * from "./TongpeiGoods.vue?vue&type=script&lang=js"
import style0 from "./TongpeiGoods.vue?vue&type=style&index=0&id=9bfe4492&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfe4492",
  null
  
)

export default component.exports